<template>
  <div>
    <a-select
      mode="multiple"
      v-model="selectedUserIds"
      placeholder="Select users"
      style="width: 100%;"
      :filter-option="false"
      :defaultActiveFirstOption="false"
      :not-found-content="fetching ? undefined : null"
      @search="fetchUser"
      @change="handleChange"
    >
      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
      <a-select-option v-for="d in data" :key="d.id">
        {{ d.fullname || d.username }}
        <small v-if="d.position"
          ><i>({{ d.position.name }})</i></small
        >
      </a-select-option>
    </a-select>
    <a-button
      type="primary"
      style="margin-top: 15px;"
      @click="addMoreUsers"
      :loading="fetching"
      >Submit</a-button
    >
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import {
  addMoreUsersToUserGroupSys,
  getUsers,
} from "@/views/configAdmin/list-permission/query.service";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    updateListUser: {
      type: Function,
      required: true,
    },
    onCloseDrawer: {
      type: Function,
      required: true,
    },
  },
  data() {
    this.lastFetchId = 0;
    this.fetchUser = debounce(this.fetchUser, 800);
    return {
      data: [],
      selectedUserIds: [],
      fetching: false,
    };
  },
  methods: {
    fetchUser(value) {
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.data = [];
      this.fetching = true;

      const params = { query: value };

      getUsers(params)
        .then(({ data }) => {
          if (fetchId !== this.lastFetchId) {
            // for fetch callback order
            return;
          }
          this.data = data.users;
          this.fetching = false;
        })
        .catch((e) => {
          this.fetching = false;
          console.log("E", e);
        });
    },
    handleChange(value) {
      // Object.assign(this, {
      //   value,
      //   data: [],
      //   fetching: false,
      // });
    },
    addMoreUsers() {
      this.fetching = true;

      const params = {
        id: this.id,
        userIds: this.selectedUserIds,
      };

      addMoreUsersToUserGroupSys(params)
        .then(({ data }) => {
          this.fetching = false;

          if (data.addMoreUsersToUserGroupSys?.users) {
            this.updateListUser(data.addMoreUsersToUserGroupSys.users);
          }
          this.selectedUserIds = [];
          this.onCloseDrawer();
        })
        .catch((e) => {
          this.fetching = false;
          this.$message.error("Lỗi không thể lưu");
          console.log("e", e);
        });
    },
  },
};
</script>
